(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["compact-product-viewer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('compact-product-viewer')) {
  customElements.define('compact-product-viewer', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.slides = Array.from(this.querySelectorAll('[data-media]'));
      this.index = 0;
      const root = document.getElementById('shopify-section-' + this.dataset.section);
      if (!root || !this.slides.length) return;
      const open = (trigger) => {
        const index = this.slides.findIndex(slide => slide.dataset.media === trigger.dataset.compactImage);
        if (index < 0) return;
        this.opener = trigger;
        this.show(index);
        this.dialog.showModal();
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.querySelector('[data-close]').focus();
      };
      root.addEventListener('click', event => {
        const trigger = event.target.closest('[data-compact-image]');
        if (trigger) { event.preventDefault(); open(trigger); }
      }, options);
      root.addEventListener('keydown', event => {
        const trigger = event.target.closest('[data-compact-image]');
        if (trigger && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault(); open(trigger);
        }
      }, options);
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
      const stage = this.querySelector('.compact-viewer-stage');
      stage.addEventListener('touchstart', event => {
        this.touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { ...options, passive: true });
      stage.addEventListener('touchend', event => {
        if (!this.touch) return;
        const dx = event.changedTouches[0].clientX - this.touch.x;
        const dy = event.changedTouches[0].clientY - this.touch.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1));
        this.touch = null;
      }, { ...options, passive: true });
      stage.addEventListener('touchcancel', () => { this.touch = null; }, options);
      this.querySelectorAll('[data-previous], [data-next]').forEach(button => { button.hidden = this.slides.length < 2; });
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.querySelector('[data-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
    disconnectedCallback() {
      if (this.dialog?.open) document.body.style.overflow = this.previousOverflow || '';
      this.controller?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
